import {makeAutoObservable} from "mobx";
import {inject, injectable} from "inversify";
import {Bindings} from "data/constants/bindings";
import {ViewController} from "data/types/structure";
import {type ILocalizationStore} from "data/stores/localization/localization.store";
import {type ILightPredictionsStore} from "data/stores/light_predictions/light_predictions.store";
import {type IModalsStore} from "data/stores/modals/modals.store";
import {ModalType} from "data/enums";

export interface ILeavePicksPageModalController extends ViewController {
	i18n: ILocalizationStore;
	get isBlocking(): boolean;
}

@injectable()
export class LeavePicksPageModalController implements ILeavePicksPageModalController {
	constructor(
		@inject(Bindings.LocalizationStore) public i18n: ILocalizationStore,
		@inject(Bindings.LightPredictionsStore) private _lpStore: ILightPredictionsStore,
		@inject(Bindings.ModalsStore) private _modalsStore: IModalsStore
	) {
		makeAutoObservable(this);
	}

	get isBlocking() {
		if (window.location.pathname === "/pick-by-seed") {
			if (this._modalsStore.modal === ModalType.LOSE_PICKS) {
				return false;
			}

			return this._lpStore.isPredictionsChanged;
		} else {
			return false; // TODO add logic for heavy predictor
		}
	}
}
